module.exports = __webpack_public_path__ + "vrplayerstatic/media/callButton.53ce0687.svg";